import gql from 'graphql-tag';

const LIQUID_M_CAMPAIGN_PAUSE = gql`
  query liquidMCampaignPause($id: Int) {
    liquidMCampaignPause(id: $id)
  }
`;

export default LIQUID_M_CAMPAIGN_PAUSE;
